module.exports = __webpack_public_path__ + "img/1482659235.d3222c77.jpg";